import React, {FC} from "react"

import {Password} from "@irati-web/fields/user"
import {useIntl} from "@irati/utils/lang"
import id from "@irati/utils/id"

interface Props {
  idNamespace: string
  password?: string
  confirm?: string
  onChange?: (label: string, updatedValue: string) => void
}

const ResetPasswordInputs: FC<Props> = ({idNamespace, password, confirm, onChange}) => {
  const {formatMessage} = useIntl()

  return (
    <>
      <Password
        id={id("field-password", idNamespace)}
        label={formatMessage({id: "platform.resetPassword.password.label"})}
        placeholder={formatMessage({id: "platform.resetPassword.password.placeholder"})}
        value={password}
        onChange={(value) => onChange("password", value)}
      />
      <Password
        id={id("field-password-confirm", idNamespace)}
        name="confirmPassword"
        label={formatMessage({id: "platform.resetPassword.confirm.label"})}
        placeholder={formatMessage({id: "platform.resetPassword.confirm.placeholder"})}
        value={confirm}
        onChange={(value) => onChange("confirm", value)}
        passwordToMatch={password}
      />
    </>
  )
}

export default ResetPasswordInputs
